import PatcraftApi from "../../../scripts/patcraft-api";
import commonMethods from "../../../scripts/common-methods";
import Cropper from 'cropperjs'; // Import the Cropper.js library
import { coverImageCroppingsTransformerForProject } from "../../../helpers"
import { cloneDeep } from 'lodash';


const state = () => ({
  selectAnotherImage: false,
  IsstartOverOrCancel: false,
  selectedProjectId: [],
  tab: "cover",
  resourceString: '',
  projectType: [],
  createProject: '',
  fileName: null,
  fileUrl: '',
  imageData: {
    thumbnail: null,
    cover: null,
  },
  imageCropData: {
    thumbnail: null,
    cover: null,

  },
  coverImageCroppings: [],
  uploadImageData: {},
  trayState: {
    coverPhoto: '',
    coverImage: ''
  },
  projectAlreadyExist: '',
  blobURL: {

  },
  imageCropped: null,
  coverCropImage: '',
  trayDetails: null,
  errorMsg: '',
  basketTitleUpdate: '',
  basketCommonErrorMsg: '',
  isBrandProject: false,
})

// Getters
const getters = {
  getselectAnotherImage: state => {
    return state.selectAnotherImage
  },
  getSelectedProjectId: state => {
    return state.selectedProjectId;
  },
  getProjectType: (state) => {
    return state.projectType;
  },
  getFileUrl: state => {
    return state.fileUrl;
  },
  getFileName: state => {
    return state.fileName;
  },
  getImageData: state => (key) => {
    return state.imageData[key] || null;
  },
  getImageCropData: state => (key) => {
    return state.imageCropData[key] || null;
  },
  getImageCoverData: state => {
    return state.imageData.cover || null;
  },
  getImageThumbnailData: state => {
    return state.imageData.thumbnail || null;
  },

  getTab: state => {
    return state.tab;
  },
  getCoverImageCroppings: state => {
    return state.coverImageCroppings
  },
  getUploadImageResp: state => {
    return state.uploadImageData
  },
  getBlobUrls: state => state.blobURL,

  getcoverCropImage: state => state.coverCropImage,

  getIsstartOverOrCancel: state => {
    return state.IsstartOverOrCancel
  },
  getTrayDetails: state => {
    return state.trayDetails
  },
}

// Mutations
const mutations = {
  setIsBrandProject(state, isBrand) {
    state.isBrandProject = isBrand;
  },
  setTrayDetails(state, data) {
    state.trayDetails = data.item2.sections.find(item => item.title == 'default').contentItems

    const outputData = [];

    state.trayDetails.forEach(item => {
      const productContentItem = item.productContentItem;

      if (productContentItem && productContentItem.productStyleImages) {
        productContentItem.productStyleImages.forEach(styleImage => {
          const sellingStyleNumber = productContentItem.productId;
          const sellingColorNumber = styleImage.colorNumber;
          const quantity = 1;
          const vehicleId = styleImage.vehicleId || "";
          const isTrayItem = true;
          const colorName = styleImage.colorName;
          const colorNumber = styleImage.colorNumber;

          outputData.push({
            sellingStyleNumber,
            sellingColorNumber,
            quantity,
            vehicleId,
            isTrayItem,
            colorName,
            colorNumber,
          });
        });
      }
    });

  },
  setProjectAlreadyExistResourceString(state, data) {
    state.projectAlreadyExist = data
  },
  setselectAnotherImage(state, data) {
    state.selectAnotherImage = data
  },
  setSelectedProjectId(state, data) {
    state.selectedProjectId = data;
  },
  setResourceString(state, data) {
    state.resourceString = data
  },
  setProjectType(state, data) {
    state.projectType = data
  },
  createProject(state, data) {
    state.createProject = data
  },
  setFileName(state, data) {
    state.fileName = data
  },
  setFileUrl(state, data) {
    state.fileUrl = data
  },
  setimageData(state, { key, cropperData }) {
    state.imageData = { ...state.imageData, [key]: cloneDeep(cropperData) };
  },
  setimageCropData(state, { key, cropperData }) {
    state.imageCropData = { ...state.imageCropData, [key]: cloneDeep(cropperData) };
  },
  setTab(state, data) {
    state.tab = data
  },
  setCoverImageCroppings(state, data) {
    state.coverImageCroppings = data
  },
  setUploadImageResp(state, { data }) {
    if (data.item2) {
      state.uploadImageData = data.item2;
      state.trayState.coverImage = state.uploadImageData.id;
      state.trayState.coverPhoto = state.uploadImageData.link
    }
    else {
      state.uploadImageData = null;
      state.trayState.coverImage = '';
      state.trayState.coverPhoto = ''
    }
  },
  setBlobUrl(state, data) {
    state.blobURL = { ...state.blobURL, ...data };
  },
  setImagelement(state, data) {
    state.imageCropped = data
  },
  setcoverCropImage(state, data) {
    state.coverCropImage = data
  },
  setstartOverOrCancel(state, data) {
    state.IsstartOverOrCancel = data
  },
  setCommonErrorMsg(state,data){
    state.errorMsg = data
  },
  basketTitleUpdate(state,data){
    state.basketTitleUpdate = data
  },
  basketCommonErrorMsg(state,data){
    state.basketCommonErrorMsg = data
  },
}

// Actions
const actions = {
  setSelectedProjectCategory({ commit }, isBrand) {
    console.log("Updating Vuex: isBrandProject =", isBrand);
    commit("setIsBrandProject", isBrand);
  },
  myProjectCommonErrorMsg({commit},data){
    commit("setCommonErrorMsg",data)
  },
  basketTitleUpdate({commit},data){
    commit("basketTitleUpdate",data)
  },
  basketCommonErrorMsg({commit},data){
    commit("basketCommonErrorMsg",data)
  },
  async updateSelectedProjectId({ commit }, trayId) {
    commit("setSelectedProjectId", trayId);
  },
  async resourceString({ commit }, resourceStringData) {
    commit("setResourceString", resourceStringData)
  },
  fetchProjectType({dispatch, commit, state }) {
    PatcraftApi.getProjectType().then((resp) => {
      commit('setProjectType', resp.data);
    }).catch((err) => {
      const error = new Error(err);
      commonMethods.handleCatch(dispatch, commit, error, state, false);
    });
  },

  updateCartCountInHeader({ commit, state }, data) {
    let type = 1;
    let cartCountElement = document.getElementsByClassName(
      "nav-top-customer-link-with-number-indicator"
    )[0];
    if (!cartCountElement) {
      type = 0;
      cartCountElement = document.getElementsByClassName(
        "nav-top-customer-link-with-number-indicator-empty"
      )[0];
    }

    if (!type) {
      cartCountElement.classList.add(
        "nav-top-customer-link-with-number-indicator"
      );
      cartCountElement.classList.remove(
        "nav-top-customer-link-with-number-indicator-empty"
      );
    }

    if(data.itemType){
      cartCountElement.innerHTML = data.count;
    }else{
      cartCountElement.innerHTML = cartCountElement
        ? parseInt(cartCountElement.innerHTML) + data.count
        : data.count;
    }
  },

  addCompareToBasket({ commit, dispatch, state }, items) {
    PatcraftApi.addMultipleItemsBasket(items)
      .then(res => {
        dispatch("updateCartCountInHeader", {count:res.data.length});
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.basketTitleUpdate,
            description: `${res.data.length} Products added to your cart.`
          },
          { root: true }
        );
        if (res && res.data && res.data.find(i => i.error))
          dispatch(
            "notifications/add",
            {
              type: "warning",
              title: state.basketTitleUpdate,
              description: res.data.find(i => i.error).error
            },
            { root: true }
          );
      })
      .catch(function (err) {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });
  },

  addTrayToBasket({ commit, dispatch, state }, items) {
    PatcraftApi.addTrayItemsToCart(items)
      .then(res => {
        let basketCount =
          res && res.data && res.data.find(i => i.basketCount)
            ? res.data.find(i => i.basketCount).basketCount
            : null;

        dispatch("updateCartCountInHeader", {count:basketCount, itemType:'Tray'});
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.basketTitleUpdate,
            description: `${basketCount} of items added to your cart.`
          },
          { root: true }
        );
        if (res && res.data && res.data.find(i => i.error))
          dispatch(
            "notifications/add",
            {
              type: "warning",
              title: state.basketTitleUpdate,
              description: res.data.find(i => i.error).error
            },
            { root: true }
          );
      })
      .catch(function (err) {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });
  },

  fetchTrayDetails({ commit, dispatch, state }, id) {
    PatcraftApi.fetchTrayDetails(id).then((resp) => {
      if (resp.data.item2 != null) {
        let trayDetails = resp?.data?.item2?.sections?.find(item => item.title == 'default')?.contentItems

        const outputData = [];

        trayDetails?.forEach(item => {
          const productContentItem = item.productContentItem;

          if (productContentItem && productContentItem.productStyleImages) {
            productContentItem.productStyleImages?.forEach(styleImage => {
              const sellingStyleNumber = productContentItem.productId;
              const sellingColorNumber = styleImage.colorNumber;
              const quantity = 1;
              const vehicleId = styleImage.vehicleId || "";
              const isTrayItem = true;
              const colorName = styleImage.colorName;
              const colorNumber = styleImage.colorNumber;

              outputData.push({
                sellingStyleNumber,
                sellingColorNumber,
                quantity,
                vehicleId,
                isTrayItem,
                colorName,
                colorNumber,
              });
            });
          }
        });
        dispatch('addTrayToBasket', outputData);

      }
      else {
        dispatch(
          "notifications/add",
          {
            type: "error",
            title: "Error",
            description:
              "An error occurred when adding the Tray to your cart."
          },
          { root: true }
        );
      }

    }).catch((err) => {
      const error = new Error(err);
      commonMethods.handleCatch(dispatch, commit, error, state, false);
    });
  },

  async getCartItemsForDuplicateTray({ commit, dispatch, state }, id) {
    return await PatcraftApi.fetchTrayDetails(id).then(async (resp) => {
      if (resp.data.item2 != null) {
        var finalArr = [];
        await resp?.data?.item2?.sections?.find(item => item.title == 'default')?.contentItems?.forEach(async(item) => {
          await item.productContentItem && item.productContentItem.productStyleImages && item.productContentItem.productStyleImages?.forEach(async(styleImage) => {
            finalArr = [...finalArr, {
              "sellingStyleNumber" : item.productContentItem.productId,
              "sellingColorNumber": styleImage.colorNumber,
              "quantity": 1,
              "vehicleId": styleImage.vehicleId || "",
              "isTrayItem": true,
              "colorName": styleImage.colorName,
              "colorNumber": styleImage.colorNumber,
              "imageXIndex": styleImage.imageXIndex,
              "imageYIndex": styleImage.imageYIndex,
              "row": styleImage.tileLeftOffset,
              "tileLeftOffset": styleImage.tileLeftOffset,
              "column": styleImage.tileTopOffset,
              "tileTopOffset": styleImage.tileTopOffset,
              "tileWidth": styleImage.tileWidth,
              "tileHeight": styleImage.tileHeight,
              "swatchWidth": styleImage.swatchWidth,
              "swatchLength": styleImage.swatchLength,
              "hexColor": styleImage.hexColor,
              "inventoryType": styleImage.inventoryType,
              "imageLink": styleImage.imageLink,
              "pdmsLink": null,
              "productType": item.productContentItem.productType,
              "sellingStyleName": item.productContentItem.productId
            }];
          });
        });
        return finalArr;
      }
      else {
        dispatch(
          "notifications/add",
          {
            type: "error",
            title: "Error",
            description: ""
          },
          { root: true }
        );
        return [];
      }

    }).catch((err) => {
      const error = new Error(err);
      commonMethods.handleCatch(dispatch, commit, error, state, true);
    });
  },




  async createProject({ commit, dispatch, state }, data) {
    let status = false;
    await PatcraftApi.createProjectFeature(data).then((resp) => {
      status = true;
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
      commit('createProject', resp.data);
    }).catch((err) => {
      status = false;
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
      }else{
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      }
    });
    return status;
  },

  async updateProject({ commit, dispatch, state }, data) {
    let status = false;
   await  PatcraftApi.updateProjectFeature(data).then((resp) => {
     if (resp.data.isSuccess) {
        status = true;
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.resourceString,
            description: ""
          },
          { root: true }
        );
      }
      else {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.errorMsg,
            description: ""
          },
          { root: true }
        );
      }
    }).catch((err) => {
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
      } else {
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      }
  });
    return status;
  },

async duplicateFromBrandBoardAction({ commit, dispatch }, data) {
  try {
    const response = await PatcraftApi.DuplicateProjectFeature(data);
    commit('createProject', response.data);

    dispatch("notifications/add", {
      type: "success",
      title: "Project duplicated successfully",
      description: "",
    }, { root: true });

    return true;
  } catch (error) {
    const statusCode = parseInt(error.message.split(" ").pop());

    if (statusCode === 409) {
      dispatch("notifications/add", {
        type: "warning",
        title: "A project with this name already exists.",
        description: "",
      }, { root: true });
    } else {
      dispatch("notifications/add", {
        type: "error",
        title: "An error occurred during duplication.",
        description: "",
      }, { root: true });
    }

    return false;
  }
},


  async selectedFileOnSaveModal({ commit }, fileName) {
    commit("setFileName", fileName)
  },
  async selectedFileUrlOnSaveModal({ commit }, fileUrl) {
    commit("setFileUrl", fileUrl)
  },

  async setImageData({ commit, state }, { key, cropperData }) {
    const currentCropData = state.imageData[key] || {};
    const updatedCropData = { ...currentCropData, ...cropperData };
    commit("setimageData", { key, cropperData: updatedCropData });
  },
  async setImageCropData({ commit, state }, { key, cropperData }) {
    const currentCropData = state.imageCropData[key] || {};
    const updatedCropData = { ...currentCropData, ...cropperData };
    commit("setimageCropData", { key, cropperData: updatedCropData });
  },
  async getNewTokenAction({ dispatch, commit, state }) {
    let newAadToken = null;
    let getAadCookie = this._vm.$cookies.get("Aad");
    if (getAadCookie) {
      let aadToken = JSON.parse(atob(getAadCookie));
      if (new Date() > new Date(aadToken.expirationDate)) {
        await PatcraftApi.getNewToken()
          .then(res => {
            newAadToken = res.data.accessToken;
          })
          .catch(err => {
            const error = new Error(err);
            commonMethods.handleCatch(dispatch, commit, error, state, false);
          });
      }
      newAadToken = aadToken.accessToken;
    }
    else {
      PatcraftApi.getNewToken()
        .then(res => {
          newAadToken = res.data.accessToken;
        })
        .catch(err => {
          const error = new Error(err);
          commonMethods.handleCatch(dispatch, commit, error, state, false);
        });

    }
    return newAadToken;
  },

  async CoverImageCroppingsAction({ commit, state }, coverImageCroppings) {
    if (coverImageCroppings) {
      commit("setCoverImageCroppings", coverImageCroppings)
    }
  },
  async updateImageResp({ commit }, uploadImageResp) {
    commit("setUploadImageResp", uploadImageResp)
  },
  clearImageData({ commit, dispatch, state }) {
    commit("setimageData", { key: 'cover', cropperData: null });
    commit("setimageData", { key: 'thumbnail', cropperData: null });
  },

  async selectAnotherImage({ commit, dispatch }, isSelectAnotherImage) {
    commit("setselectAnotherImage", isSelectAnotherImage)

  },

  async startOverOrCancel({ commit, dispatch }, isstartOverOrCancel) {
    commit("setstartOverOrCancel", isstartOverOrCancel)
  },
  async uploadImage({ commit, dispatch, state }, fileData) {
    await PatcraftApi.uploadImage(fileData)
      .then(res => {
        commit("setUploadImageResp", res)
        dispatch("setImageBlobs")
        dispatch("CoverImageCroppingsAction", coverImageCroppingsTransformerForProject(state.imageData, undefined, state.imageCropData))
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: "Image Upload Sucessfuly",
            description: ""
          },
          { root: true }
        );
        const querystr = `crop=true&anchor=${state.coverImageCroppings[0].offsetWidth}%2c${state.coverImageCroppings[0].offsetHeight}&w=${state.coverImageCroppings[0].width}&h=${state.coverImageCroppings[0].height}`
        commit('setcoverCropImage', state.uploadImageData?.link + '&' + querystr);
        dispatch("startOverOrCancel", false)
        dispatch("selectAnotherImage", true)

      })
      .catch(err => {
        const error = new Error(err);
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      });

  },
  async setTab({ commit }, tabName) {
    commit("setTab", tabName)
  },

  fetchProjectDetails({dispatch, commit, state }, id) {
    PatcraftApi.fetchProjectDetails(id).then((resp) => {
    }).catch((err) => {
      const error = new Error(err);
      commonMethods.handleCatch(dispatch, commit, error, state, false);
    });
  },

  async projectAlreadyExistResourceString({ commit }, resourceStringData) {
    commit("setProjectAlreadyExistResourceString", resourceStringData)
  },

  // Add item to product
  async createProductItem({ commit, dispatch, state }, data) {
    return await PatcraftApi.createProductItem(data).then(res => {
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
      return true;
    }).catch(err => {
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
        return 409;
      } else {
        commonMethods.handleCatch(dispatch, commit, error, state, true);
        return false;
      }
    });
  },

  async updateProductItem({ commit, dispatch, state }, data) {
    let status = false;
    await PatcraftApi.updateProductItem(data).then(res => {
      status = true;
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
    }).catch(err => {
      status = false;
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
      } else {
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      }
    });
    return status;
  },

  async updateProductColorImg({ commit, dispatch, state }, data) {
    let status = false
    await PatcraftApi.updateProductColorImg(data).then(res => {
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
      status = true;
    }).catch(err => {
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
      } else {
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      }
    });
    return status;
  },
  async updateProductFeatureImg({ commit, dispatch, state }, data) {
    let status = false;
    await PatcraftApi.updateProductFeatureImg(data).then(res => {
      status = true;
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
    }).catch(err => {
      status = false;
      const error = new Error(err);
      const statusCode = parseInt(error.message.split(" ").pop());
      if (statusCode == 409) {
        dispatch(
          "notifications/add",
          {
            type: "success",
            title: state.projectAlreadyExist,
            description: ""
          },
          { root: true }
        );
      } else {
        commonMethods.handleCatch(dispatch, commit, error, state, true);
      }
    });
    return status;
  },

  async setImagelement({ commit }, imagelement) {
    commit("setImagelement", imagelement)
  },
  async setImageBlobs({ state, commit }) {

    for (const key in state.imageData) {
      if (Object.prototype.hasOwnProperty.call(state.imageData, key)) {
        let cropper = new Cropper(state.imageData[key].image);
        commit("setBlobUrl", ({ [key]: state.imageData[key].image.src }));
        cropper?.getCroppedCanvas()?.toBlob((blob) => {
          if (blob) {
            const blobURL = URL.createObjectURL(blob);
          }
        });
      }

    }


  },
  async CoverImageCroppingsAction({ commit, state }, coverImageCroppings) {
    if (coverImageCroppings) {
      commit("setCoverImageCroppings", coverImageCroppings)
    }
  },
  async updateImageBlobd({ commit }, blobUrl) {
    commit("setBlobUrl", blobUrl)
  },
  deleteProjectFeatureItems({ commit, dispatch, state }, data) {
    PatcraftApi.deleteProjectFeatureItems(data).then((resp) => {
      dispatch(
        "notifications/add",
        {
          type: "success",
          title: state.resourceString,
          description: ""
        },
        { root: true }
      );
      window.location.reload();
    }).catch((err) => {
      const error = new Error(err);
      commonMethods.handleCatch(dispatch, commit, error, state, true);
      return false;
    });
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
